/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum BotKind {
  BOT_PP = 'BOT_PP',
  NONE = 'NONE'
}

/**
 * BotKind
 *
 * The different kinds of bots
 */
export const BotKindEnumType = types.enumeration('BotKind', ['BOT_PP', 'NONE'])
